// Spreadsheets run a cell that starts with one of these as a formula; a
// leading apostrophe keeps a name or note plain text.
const FORMULA_START = /^[=+\-@\t\r]/;

/** One CSV cell: quoted when it has to be, and never a formula. */
export function csvCell(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '';
  let text = String(value);
  if (typeof value === 'string' && FORMULA_START.test(text)) text = `'${text}`;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * Rows as a CSV document: CRLF line ends, and a byte order mark so Excel
 * reads it as UTF-8 (ø, å, ñ).
 */
export function csvDocument(
  rows: readonly (readonly (string | number | null | undefined)[])[],
): string {
  return `\uFEFF${rows.map((row) => row.map(csvCell).join(',')).join('\r\n')}\r\n`;
}

/** Downloads text as a CSV file. */
export function downloadCsv(filename: string, csv: string): void {
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/** A name safe in a filename: "Scottish Sea Farms" -> "scottish-sea-farms". */
export function filenamePart(name: string): string {
  return (
    name
      .toLowerCase()
      // Letters that don't decompose into a base letter and an accent.
      .replace(/ø/g, 'o')
      .replace(/æ/g, 'ae')
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'export'
  );
}
